/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
import React from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDBadge from "../../../components/MDBadge";
import { IconButton, MenuItem, Select, Tooltip } from "@mui/material";
import EditNoteIcon from "@mui/icons-material/EditNote";

const ROLES = [
  { id: 1, name: "Admin" },
  { id: 2, name: "Product Manager" },
  { id: 3, name: "Sales Manager" },
  { id: 4, name: "Account Manager" },
  { id: 5, name: "Godown Manager" },
];

export default function buildUserTable(data, onEdit, onRoleChange) {
  const UserName = ({ name, role }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      <MDBox ml={2}>
        <MDTypography display="block" variant="button" fontWeight="medium">
          {name}
        </MDTypography>
        <MDTypography variant="caption">{role}</MDTypography>
      </MDBox>
    </MDBox>
  );

  const columns = [
    { Header: "name", accessor: "userName", width: "45%", align: "left" },
    { Header: "email", accessor: "email", align: "center" },
    { Header: "role", accessor: "role", align: "center" },
    { Header: "action", accessor: "action", align: "center" },
  ];

  const rows = data.map((item) => {
    return {
      userName: <UserName name={item.name} role={item.role} />,
      email: (
        <MDTypography display="block" variant="button" fontWeight="medium">
          {item.email}
        </MDTypography>
      ),
      role: (
        <MDTypography display="block" variant="button" fontWeight="medium">
          {item.role}
        </MDTypography>
        // <Select
        //   value={item.roleId || ""}
        //   onChange={(e) => onRoleChange(item.id, e.target.value)}
        //   size="small"
        //   variant="outlined"
        // >
        //   <MenuItem value="">— Select Role —</MenuItem>
        //   {ROLES.map((role) => (
        //     <MenuItem key={role.id} value={role.id}>
        //       {role.name}
        //     </MenuItem>
        //   ))}
        // </Select>
      ),
      action: (
        <Tooltip title="Edit">
          <IconButton
            color="info"
            size="small"
            onClick={(e) => {
              e.preventDefault();
              onEdit(item.id);
            }}
          >
            <EditNoteIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      ),
    };
  });

  return { columns, rows };
}
